// Generated by scripts/build-ui-icons.mjs.
export { ImageSquare as default } from "../ui/glyphs-4";
